import React from "react";

import { AdminLocationAlertCreateForm } from "./Form";
import { LocationAlertData } from "../../../models/LocationAlert";
import "./styles.scss";

interface AdminLocationAlertCreateModalProps {
  onClose: () => void;
  submit: (data: any) => Promise<void>;
  locationAlert?: LocationAlertData;
}

export const AdminLocationAlertCreateModal: React.FC<
  AdminLocationAlertCreateModalProps
> = ({ onClose, submit, locationAlert }) => {
  return (
    <div className="modal modal-default">
      <div className="modal-mains modal-edit-alert">
        <button className="btn-close" onClick={onClose}></button>
        <AdminLocationAlertCreateForm
          submit={submit}
          locationAlert={locationAlert}
        />
      </div>
    </div>
  );
};
